import { render, staticRenderFns } from "./scLive.vue?vue&type=template&id=eb813e28&scoped=true&"
import script from "./scLive.vue?vue&type=script&lang=js&"
export * from "./scLive.vue?vue&type=script&lang=js&"
import style0 from "./scLive.vue?vue&type=style&index=0&id=eb813e28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb813e28",
  null
  
)

export default component.exports